// Design tokens extraídos do Dashboard121Insights (v45) — Apple-like system.
// Todos os componentes em src/components/ui/ importam daqui para manter o
// design language consistente com o dashboard principal.

export const C = {
  // Unimed greens
  g900: "#003E1F",
  g800: "#005229",
  g700: "#006633",
  g600: "#008040",
  g500: "#00994D",
  g400: "#00B35A",
  g300: "#4DC87E",
  g200: "#B3E6C8",
  g100: "#E5F5EC",
  g50: "#F0FAF4",
  // 121 purple
  p700: "#3D2B9E",
  p600: "#5243C2",
  p500: "#7B6CF6",
  p400: "#A99DF9",
  p100: "#EEE9FF",
  // Neutrals — Apple style
  bg: "#F5F5F7",
  surface: "#FFFFFF",
  surf2: "#FAFAFA",
  surf3: "#F5F5F7",
  border: "#E8E8ED",
  border2: "#D2D2D7",
  text: "#1D1D1F",
  text2: "#3D3D3F",
  text3: "#6E6E73",
  text4: "#AEAEB2",
  // Semantic
  red: "#FF3B30",
  redBg: "#FFF5F5",
  orange: "#FF9500",
  orangeBg: "#FFFAF0",
  yellow: "#FFCC00",
  green: "#34C759",
  greenBg: "#F0FFF4",
  blue: "#007AFF",
  blueBg: "#F0F5FF",
  purple: "#AF52DE",
  purpleBg: "#F8F0FF",
  // Chart zones
  zCrit: "#FF3B3009",
  zWarn: "#FF950009",
  zOk: "#FFCC0009",
  zGood: "#34C75909",
  white: "#FFFFFF",
};

export const F = {
  display:
    "-apple-system,BlinkMacSystemFont,'SF Pro Display','Helvetica Neue',sans-serif",
  text: "-apple-system,BlinkMacSystemFont,'SF Pro Text','Helvetica Neue',sans-serif",
  mono: "'SF Mono','Monaco','Cascadia Code','Roboto Mono',monospace",
};

export const PER = {
  mensal: { label: "Março 2026", short: "Mar/26", ondas: 1, resp: 214 },
  trimestral: { label: "T1 2026", short: "T1/26", ondas: 3, resp: 612 },
  semestral: { label: "S2 2025", short: "S2/25", ondas: 2, resp: 1184 },
  anual: { label: "Ano 2025", short: "2025", ondas: 4, resp: 2384 },
};

export const PER_OPTIONS = {
  mensal: [
    "Abr/26",
    "Mar/26",
    "Fev/26",
    "Jan/26",
    "Dez/25",
    "Nov/25",
    "Out/25",
    "Set/25",
  ],
  trimestral: ["T2/26", "T1/26", "T4/25", "T3/25", "T2/25", "T1/25"],
  semestral: ["S1/26", "S2/25", "S1/25", "S2/24", "S1/24"],
  anual: ["2026", "2025", "2024", "2023", "2022"],
};

export const PER_DEFAULT_LABELS = {
  mensal: "Mar/26",
  trimestral: "T1/26",
  semestral: "S2/25",
  anual: "2025",
};

export const PILLAR_COLORS = {
  Sucesso: "#16a34a",
  Esforço: "#0284c7",
  Emoção: "#7c3aed",
};

// CES/CSAT color scales — usado por DistBar
export const CES_COLS = [
  { k: "ef", c: "#059669", l: "Ext.Fácil" },
  { k: "f", c: "#34c759", l: "Fácil" },
  { k: "n", c: "#f59e0b", l: "Normal" },
  { k: "d", c: "#ef4444", l: "Difícil" },
  { k: "ed", c: "#dc2626", l: "Ext.Difícil" },
];

export const CSAT_COLS = [
  { k: "ms", c: "#059669", l: "5 — Muito Satisfeito" },
  { k: "s", c: "#34c759", l: "4 — Satisfeito" },
  { k: "r", c: "#f59e0b", l: "3 — Razoável" },
  { k: "i", c: "#ef4444", l: "2 — Insatisfeito" },
  { k: "mi", c: "#dc2626", l: "1 — Muito Insatisfeito" },
];
